import React from 'react'
import ToastConsumer from './ToastConsumer'

function withToastConsumer(Component) {
  return function withToastConsumer(props) {
    return (
      <ToastConsumer>
        {({ showToast }) => <Component {...props} showToast={showToast} />}
      </ToastConsumer>
    )
  }
}

export default withToastConsumer
